module.exports = { "default": require("core-js/library/fn/reflect/own-keys"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/reflect/own-keys.js
// module id = x4/c
// module chunks = 3